var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-settings-sidebar',{attrs:{"temporary":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-list-tile',{staticClass:"py-4"},[_c('v-classification-selector')],1),_c('v-features')],1)}
var staticRenderFns = []

export { render, staticRenderFns }